// must mirror DB state
export enum FinancialDataObjectTypeEnum {
  ENTITY = 1,
  MNE,
  TESTED_PARTY,
}
